export default {
	teams: [],
	totalTeams: 0,
	assignedTeams: [],
};
